export const REDUX_BROADCAST_CHANNEL = 'rwf-redux-sync';

/**
 * Centralized list of Redux action types that should be synchronized
 * across already-open tabs in real time.
 */
export const reduxBroadcastActionTypes = [
    'auth/login',
    'auth/logout',
    'auth/updateUser',
    'auth/setToken',
    'servicePointProfile/setServicePointProfile',
    'servicePointProfile/clearServicePointProfile',
] as const;
